import { fork, all } from 'redux-saga/effects';

import { watchAgencyLocations } from './agencyLocations';
import { watchAlert } from './alert';
import { watchAlertArticlePage } from './alertArticlePage';
import { watchAlerts } from './alerts';
import { watchApp } from './app';
import { watchAppHistory } from './appHistory';
import { watchCartItems } from './cartItems';
import { watchCategories } from './categories';
import { watchCatSalesAndMarketing } from './catSalesAndMarketing';
import { watchCatSystemAndTech } from './catSystemAndTech';
import { watchCollateralRequest } from './collateralRequest';
import { watchCollateralTemplate } from './collateralTemplate';
import { watchCustomerLists } from './customerLists';
import { watchDateRange } from './dateRange';
import { watchDynamic } from './dynamic';
import { watchError } from './error';
import { watchFavoritePages } from './favoritePages';
import { watchFeaturedFieldManagementNews } from './featuredFieldManagementNews';
import { watchFeaturedProductUpdates } from './featuredProductUpdates';
import { watchFeaturedSales } from './featuredSales';
import { watchFieldManagements } from './fieldManagements';
import { watchFieldManagement } from './fieldManagment';
import { watchFindGuideLines } from './findGuideLines';
import { watchGuide } from './guide';
import { watchGuides, watchGuidesByState } from './guides';
import { watchHomeArticles } from './homeArticles';
import { watchImpactingPolicies } from './impactingPolicies';
import { watchImpactingPolicy } from './impactingPolicy';
import {
    watchJobAids,
    watchMonthlyJobAids,
    watchPrelaunchJobAids,
} from './jobAids';
import { watchMenus } from './menus';
import {
    watchPlatforms,
} from './platforms';
import { watchProduct } from './product';
import { watchProducts } from './products';
import { watchProductUpdates } from './productUpdates';
import { watchQueryTimeStamps } from './queryTimeStamps';
import { watchRedirectRecords } from './redirectRecords';
import { watchRsm } from './rsm';
import { watchRsmSearchResults } from './rsmSearchResults';
import { watchSales } from './sales';
import { watchSalesPromotion } from './salesPromotion';
import { watchSalesPromotions } from './salesPromotions';
import { watchSandwichMenu } from './sandwichMenu';
import { watchSavedMegaQuery } from './savedMegaQuery';
import { watchSearch } from './search';
import { watchSelected } from './selected';
import { watchSimplePages } from './simplePages';
import { watchStates } from './states';
import { watchStaticCohorts } from './staticCohorts';
import { watchStaticFooter } from './staticFooter';
import { watchStaticHome } from './staticHome';
import { watchStatics } from './statics';
import { watchTags } from './tags';
import { watchTopMenuClicked } from './topMenuClicked';
import { watchTraining } from './training';
import { watchTrainingPageLoaded } from './trainingPageLoaded';
import { watchTrainings } from './trainings';
import { watchTrainingsAllSystem } from './trainingsAllSystem';
import { watchTrainingsAllTypes } from './trainingsAllTypes';
import { watchTrainingsFilter } from './trainingsFilter';
import { watchUncheckedAlertsCount } from './uncheckedAlertsCount';
import { watchUncheckedByCategoryCount } from './uncheckedByCategoryCount';
import { watchUncheckedImpactingPolicyCount } from './uncheckedImpactingPolicyCount';
import { watchWebinars } from './webinars';
import { watchWebinarsFilter } from './webinarsFilter';
import { dynamicSagas as extraForks } from '../utils/dynamicHelpers';

const Forks = [
    fork(watchApp),
    fork(watchAgencyLocations),
    fork(watchCustomerLists),
    fork(watchAlert),
    fork(watchAlerts),
    fork(watchCartItems),
    fork(watchCategories),
    fork(watchCatSalesAndMarketing),
    fork(watchCatSystemAndTech),
    fork(watchCollateralRequest),
    fork(watchCollateralTemplate),
    fork(watchDateRange),
    fork(watchFavoritePages),
    fork(watchFeaturedFieldManagementNews),
    fork(watchFeaturedProductUpdates),
    fork(watchFeaturedSales),
    fork(watchFieldManagement),
    fork(watchFieldManagements),
    fork(watchGuide),
    fork(watchGuides),
    fork(watchHomeArticles),
    fork(watchJobAids),
    fork(watchMonthlyJobAids),
    fork(watchGuidesByState),
    fork(watchMenus),
    fork(watchImpactingPolicy),
    fork(watchImpactingPolicies),
    fork(watchPrelaunchJobAids),
    fork(watchProduct),
    fork(watchProducts),
    fork(watchPlatforms),
    fork(watchProductUpdates),
    fork(watchRedirectRecords),
    fork(watchRsm),
    fork(watchSavedMegaQuery),
    fork(watchSales),
    fork(watchSalesPromotion),
    fork(watchSalesPromotions),
    fork(watchSearch),
    fork(watchSimplePages),
    fork(watchStates),
    fork(watchStaticCohorts),
    fork(watchStaticFooter),
    fork(watchStaticHome),
    fork(watchStatics),
    fork(watchTags),
    fork(watchTraining),
    fork(watchTrainings),
    fork(watchQueryTimeStamps),
    fork(watchUncheckedByCategoryCount),
    fork(watchUncheckedAlertsCount),
    fork(watchUncheckedImpactingPolicyCount),
    fork(watchWebinars),

    fork(watchSelected),

    fork(watchAppHistory),
    fork(watchFindGuideLines),
    fork(watchSandwichMenu),
    fork(watchTopMenuClicked),
    fork(watchTrainingsAllSystem),
    fork(watchTrainingsAllTypes),
    fork(watchTrainingsFilter),
    fork(watchWebinarsFilter),
    fork(watchTrainingPageLoaded),
    fork(watchRsmSearchResults),

    fork(watchAlertArticlePage),
    fork(watchError),
];

const ForkDrawer = () => {
    for (let i = 0; i < extraForks.length; i++) {
        Forks.push(fork(watchDynamic, extraForks[i]));
    }

    return Forks;
};

export default function * Sagas() {
    yield all(ForkDrawer());
}
